import Selectors from './selectors.js';

const selectors = new Selectors();

export default class FormFieldHandler {
    getFormValues(element) {
        const fields = selectors.querySelectorArray(element + ' input');
        let result = {};
        for (let count = 0; count < fields.length; ++count) {
            result[fields[count].name] = fields[count].value;
        }
        return result;
    }
}
